import { AudioTeaserEntry, TeaserEntry } from "../helper/interfaces";
import React, { useContext } from "react";
import { AppContext } from "../provider/AppContextProvider";
import { getTeaserTypeIcons, getTeaserImageUrl } from "../helper/images";
import CustomImage from "./ui/Image";
import { AdInformationInterface } from "../helper/PageInformationInterface";
import { PlayCircle, PauseCircle } from "react-feather";

export interface TeaserData {
  teaser: TeaserEntry;
  className?: string;
  navigate?: (articleId: string, ressortId: string) => void;
  adInformation?: AdInformationInterface;
  ignoreLead?: boolean;
  isImportantTeaser?: boolean;
  showImage?: boolean;
  showResorts?: boolean;
  isAlreadyLinked?: boolean;
}

function TeaserAudioMinimizedNN(data: TeaserData) {
  const teaser = data.teaser;

  const image = teaser?.images ? teaser.images[0] : undefined;
  const imageUrl = image && getTeaserImageUrl(image);

  const teaserClassName = `teaser teaser-minimized teaser-minimized-type-${
    teaser.type
  } ${imageUrl ? "teaser--image" : ""} ${
    teaser.featured ? "teaser--featured" : ""
  } ${data.className ? data.className : ""} 
  ${data.isImportantTeaser ? "teaser-minimized__important" : ""}`;

  const { audioPlayer, setAudioPlayer } = useContext(AppContext);
  const resortsData = teaser.ressort?.split(",") || [];

  let icons = getTeaserTypeIcons(teaser.teaserTypes);

  return (
    <>
      <button
        key={`teaser-link-${teaser.id}`}
        data-name={`article-${teaser.id}`}
        className={teaserClassName}
        onClick={() => {
          setAudioPlayer({
            topline: teaser.topline,
            title: teaser.title,
            playing: !(
              audioPlayer?.playing &&
              audioPlayer.audioUrl === (teaser as AudioTeaserEntry).audioUrl
            ),
            audioUrl: (teaser as AudioTeaserEntry).audioUrl,
            imageUrl: imageUrl,
          });
        }}
      >
        <div>
          {teaser.paid && !teaser.hidePlusIcon && (
            <div className="flex items-center gap-2 mb-2.5">
              {teaser.paid && !teaser.hidePlusIcon && <div className="linkbox-nn">NN+</div>}
            </div>
          )}
          <div className="flex items-stretch">
            {imageUrl && (
              <div className="teaser-image">
                <div className="teaser-podcast-play play-button-overlay">
                  {audioPlayer?.playing &&
                  audioPlayer.audioUrl ===
                    (teaser as AudioTeaserEntry).audioUrl ? (
                    <div className=" pause-button">
                      <PauseCircle />
                    </div>
                  ) : (
                    <div className="play-button">
                      <PlayCircle />
                    </div>
                  )}
                </div>
                {data.showImage && (
                  <CustomImage
                    src={imageUrl}
                    //fill
                    layout="fill"
                    //height="100%"
                    //width="150px" height="100%"
                    objectFit="cover"
                    alt={image.title}
                  />
                )}
                {teaser.paid && !teaser.hidePlusIcon && (
                  <div className="teaser-info">
                    <div className="icon-nnplus" aria-label="NN+"></div>
                  </div>
                )}
              </div>
            )}
            <div className="teaser-body flex-1">
              {teaser.subline && (
                <div className="">
                  <div className="teaser-time">
                    {teaser.subline}
                  </div>
                </div>
              )}

              {teaser.topline && (
                <div className="teaser-info">
                  <div className="teaser-topline">
                    <div>{teaser.topline}</div>
                  </div>
                </div>
              )}
              {teaser.title && <h3 className="teaser-title">{teaser.title}</h3>}
            </div>
          </div>
        </div>
      </button>
    </>
  );
}

export default TeaserAudioMinimizedNN;
